export default __webpack_public_path__ + "static/media/vehicle_other.7bd1082b.svg";